import React from "react";
import SmartScanSubmittedPage from "../../components/SmartScanSubmitted/SmartScanSubmittedPage";

const SmartScanSubmitted = () => {
  return (
    <>
      <body className="mobile-body">
        <div className="body-content">
          <section className="review-photo-section py-4 py-md-5">
            <SmartScanSubmittedPage />
          </section>
        </div>
      </body>
    </>
  );
};

export default SmartScanSubmitted;
